import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'var(--ink-50)' }}>
      <div className="w-full max-w-lg">
        <Outlet />
      </div>
    </div>
  )
}
